export enum MetroStationsActions {
  GetMetroStations = '[Pending] Get Metro Stations',
  GetMetroStationsSuccess = '[Success] Get Metro Stations',
  GetMetroStationsError = '[Error] Get Metro Stations',
}
